export enum QRCodeItemPanels {
  NONE = 'none',
  COLOR_FILL = 'color-fill',
  BACKGROUND = 'background',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
